import { css, StyleSheet } from 'aphrodite';
import { forwardRef, InputHTMLAttributes, useId } from 'react';
import { FieldError } from 'react-hook-form';
import {
	InputGroupAddon,
	InputGroupInput,
	InputGroupText,
	InputGroupV2,
} from '../../../../../web/components-v2/InputGroup';
import { bs } from '../../../../../web/styles/styles';
import { InfoPopover } from '../../../../components/InfoPopover/InfoPopover';
import { Column, Row } from '../../../../components/Layout';
import { styleSheet } from '../../../../components/blogs/styles';

interface FontSizeInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
	error?: FieldError;
	label: string;
}

export const FontSizeInput = forwardRef<HTMLInputElement, FontSizeInputProps>(
	({ error, id, label, placeholder = 'Native', ...props }, ref) => {
		const generatedId = useId();
		const inputId = id ?? generatedId;

		return (
			<Column className={css(bs.justifyCenter)}>
				<Row className={css(styleSheet.labelRow)}>
					<label className={css(styleSheet.label)} htmlFor={inputId}>
						{label}
					</label>
					{!!error && <InfoPopover message={error.message} variant='error' />}
				</Row>
				<InputGroupV2 styles={[fontSizeInputStyleSheet.inputShell]}>
					<InputGroupInput
						aria-invalid={error ? 'true' : undefined}
						aria-label={`${label} (px)`}
						id={inputId}
						inputMode='numeric'
						placeholder={placeholder}
						ref={ref}
						styles={[fontSizeInputStyleSheet.input]}
						type='text'
						{...props}
					/>
					<InputGroupAddon align='inlineEnd'>
						<InputGroupText>px</InputGroupText>
					</InputGroupAddon>
				</InputGroupV2>
			</Column>
		);
	}
);
FontSizeInput.displayName = 'FontSizeInput';

const fontSizeInputStyleSheet = StyleSheet.create({
	inputShell: {
		width: '100%',
		height: 42,
	},
	input: {
		fontVariantNumeric: 'tabular-nums',
		textAlign: 'left',
	},
});
